import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Add as AddIcon,
  CalendarMonthOutlined as CalendarIcon,
  DescriptionOutlined as ReportIcon,
  LocalGasStationOutlined as GasoilIcon,
  MoreHorizRounded as MoreIcon,
} from "@mui/icons-material";

type MobileBottomNavigationProps = {
  active?: "timeline" | "report" | "gasoil";
  onAdd: () => void;
};

const MobileBottomNavigation: React.FC<MobileBottomNavigationProps> = ({
  active = "timeline",
  onAdd,
}) => {
  const { t } = useTranslation();

  const openMobileMenu = () => {
    window.dispatchEvent(new Event("open-mobile-navigation"));
  };

  return (
    <nav className="mobile-planning-bottom-nav" aria-label={t("mobileNavigation", "Mobile navigation")}>
      <Link
        className={`mobile-planning-nav-item${active === "timeline" ? " is-active" : ""}`}
        to="/mobile/planning"
      >
        <CalendarIcon />
        <span>{t("timeline", "Timeline")}</span>
      </Link>

      <Link
        className={`mobile-planning-nav-item${active === "report" ? " is-active" : ""}`}
        to="/reports/weekly-report"
      >
        <ReportIcon />
        <span>{t("reports", "Report")}</span>
      </Link>

      <button
        type="button"
        className="mobile-planning-nav-add"
        onClick={onAdd}
        aria-label={t("add", "Add")}
      >
        <AddIcon />
      </button>

      <Link
        className={`mobile-planning-nav-item${active === "gasoil" ? " is-active" : ""}`}
        to="/mobile/gasoil"
      >
        <GasoilIcon />
        <span>{t("gasoil", "Gasoil")}</span>
      </Link>

      <button
        type="button"
        className="mobile-planning-nav-item mobile-planning-nav-more"
        onClick={openMobileMenu}
        aria-label={t("more", "More")}
      >
        <MoreIcon />
        <span>{t("more", "More")}</span>
      </button>
    </nav>
  );
};

export default MobileBottomNavigation;
